/** @format */
import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const IconsBox = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

export {IconsBox};
